import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import api from '../api'
import Lockr from 'Lockr'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        g_city: {
            'id': 226,
            'name': '上海'
        },
        g_searchParam: {
            'cityId': 226,
            'hotelCode': '',
            'startDate': '',
            'endDate': '',
            'promotionType': '',
            'HotelTypeId': '',
            'areaId': '',
            'pointX': '',
            'pointY': '',
            'PointType': 0,
            'PointText': '',
            'Sort': 1,
            'SortType': 'asc',
            'Sorttype':'',
            'PageIndex': 1,
            'PageSize': 10,
            'isFull':'',
            'lng':'',
            'lat':'',
            'hotPointId':'',
            //会议室开始时间
            'startTime':'',
            'endTime':''
        },
        g_relaxParam:{
            
        },
        g_searchKeyWord: '按行政区/商圈/门店查询',
        g_currentCityName: '上海',
        g_UserInfo: {
 
        },
        //用户登录信息
        g_loginInfo:{
          'Card_no':''
        },
        g_PayOrder:{
            'OrderId':'',
            'Money':'',
            'Date':'',
            'TypeName':'',
            'TypeId': '0'
        },
        //储值卡充值信息
        g_rechargeMsg: '',
        //银联卡卡号
        g_accountNumber: '',
        //钱包余额
        g_walletInfo: {
            'myCash': '',
            'unionPayCash': '',
            'KCoin': '',
            'vouchers': '',
            'StoreCardMoney':'',
            'MallCoin':'',
        },
        //当前酒店的基本信息
        g_currentInfo:{},
        //当前酒店的折扣
        g_currentDiscount:{},
        //当前选中的房型信息
        g_currentRoom:{},
        //当前订单信息
        g_currentOrder:{
            hotalName: '',
            roomName: '',
            startDate: '',
            endDate: '',
            days: '',
            cusName: '',
            phoneNum: '',
            mail:'',
            cusNum: '',
            roomNum: '',
            require: '',
            invoice: '',
            coupon: '',
            amount: '',
            InvoiceNo:'',
            //免房券信息
            freeVoucherInfo:{
                //使用免房券
                useNotSee:false,
                //当前选中的免房券编号
                selected:'', 
                //免房券金额
                amount:0
            },
        },
        //保存用户一些状态信息
        g_userState:{
            //是否开通了储值卡
            openedValueCard:'',
        },
        //是否需要刷新页面
        g_freshList:{
          orderList:false
        },
        g_jdpayList:{
            'version':'',
            'merchant':'',
            'device':'',
            'tradeNum':'',
            'tradeName': '',
            'tradeDesc': '',
            'tradeTime': '',
            'amount': '',
            'currency': '',
            'note': '',
            'callbackUrl': '',
            'notifyUrl': '',
            'ip': '',
            'userType': '',
            'userId': '',
            'expireTime': '',
            'orderType': '',
            'industryCategoryCode': '',
            'specCardNo': '',
            'specId': '',
            'specName': '',
            'sign':''
        },
        // 早餐券（多个）信息
        g_breakfastInfo:{},
    },
    getters: {
        g_city: function(state) {
            var _g_city = Lockr.get('g_city');
            if (_g_city)
                state.g_city = _g_city;
            return state.g_city
        },
        g_searchParam: function(state) {
            var _g_searchParam = Lockr.get('g_searchParam');
            if (_g_searchParam)
                state.g_searchParam = _g_searchParam;
            return state.g_searchParam;
        },
        g_searchKeyWord: function(state) {
            var _g_searchKeyWord = Lockr.get('g_searchKeyWord');
            if (_g_searchKeyWord)
                state.g_searchKeyWord = _g_searchKeyWord;

            if (state.g_searchKeyWord =="")
                state.g_searchKeyWord = "按行政区/商圈/门店查询";

            return state.g_searchKeyWord;
        },
        g_currentCityName: function(state) {
            var _g_currentCityName = Lockr.get('g_currentCityName');
            if (_g_currentCityName)
                state.g_currentCityName = _g_currentCityName;
            return state.g_currentCityName
        },
        // g_UserInfo: state => state.g_UserInfo,
        g_UserInfo: function(state) {
            var _g_UserInfo = Lockr.get('g_UserInfo');
            if (_g_UserInfo)
                state.g_UserInfo = _g_UserInfo;
            return state.g_UserInfo
        },
        g_loginInfo: function(state) {
            var _g_loginInfo = Lockr.get('g_loginInfo');
            if (_g_loginInfo)
                state.g_loginInfo = _g_loginInfo;
            return state.g_loginInfo
        },
        g_userState: function(state) {
            var _g_userState = Lockr.get('g_userState');
            if (_g_userState)
                state.g_userState = _g_userState;
            return state.g_userState
        },
        g_PayOrder: function(state) {
            var _g_PayOrder = Lockr.get('g_PayOrder');
            if (_g_PayOrder)
                state.g_PayOrder = _g_PayOrder;
            return state.g_PayOrder
        },

        g_walletInfo: function(state) {
            var _g_walletInfo = Lockr.get('g_walletInfo');
            if (_g_walletInfo)
                state.g_walletInfo = _g_walletInfo;
            return state.g_walletInfo
        },
        g_currentInfo: function(state) {
            var _g_currentInfo = Lockr.get('g_currentInfo');
            if (_g_currentInfo)
                state.g_currentInfo = _g_currentInfo;
            return state.g_currentInfo
        },
        g_breakfastInfo: function(state) {
            var _g_breakfastInfo = Lockr.get('g_breakfastInfo');
            if (_g_breakfastInfo)
                state.g_breakfastInfo = _g_breakfastInfo;
            return state.g_breakfastInfo
        },
        g_currentDiscount: function(state) {
            var _g_currentDiscount = Lockr.get('g_currentDiscount');
            if (_g_currentDiscount)
                state.g_currentDiscount = _g_currentDiscount;
            return state.g_currentDiscount
        },
        g_currentRoom: function(state) {
            var _g_currentRoom = Lockr.get('g_currentRoom');
            if (_g_currentRoom)
                state.g_currentRoom = _g_currentRoom;
            return state.g_currentRoom
        },
        g_currentOrder: function(state) {
            var _g_currentOrder = Lockr.get('g_currentOrder');
            if (_g_currentOrder)
                state.g_currentOrder = _g_currentOrder;
            return state.g_currentOrder
        },
        g_rechargeMsg: function(state) {
            var _g_rechargeMsg = Lockr.get('g_rechargeMsg');
            if (_g_rechargeMsg)
                state.g_rechargeMsg = _g_rechargeMsg;
            return state.g_rechargeMsg
        },
        //g_rechargeAmount: state => state.g_rechargeAmount,
        g_accountNumber: state => state.g_accountNumber,
        g_freshList: state => state.g_freshList,
        g_jdpayList: function(state) {
            var _g_jdpayList = Lockr.get('g_jdpayList');
            if (_g_jdpayList)
                state.g_jdpayList = _g_jdpayList;
            return state.g_jdpayList
        },
    },
    mutations: {
        setG_city(state, g_city) {
            state.g_city = g_city;
            Lockr.set('g_city', g_city);
        },
        setG_searchParam(state, g_searchParam) {
            state.g_searchParam = g_searchParam;
            Lockr.set('g_searchParam', g_searchParam);
        },
        setG_searchKeyWord(state, g_searchKeyWord) {
            state.g_searchKeyWord = g_searchKeyWord
            Lockr.set('g_searchKeyWord', g_searchKeyWord);
        },
        setG_currentCityName(state, g_currentCityName) {
            state.g_currentCityName = g_currentCityName;
            Lockr.set('g_currentCityName', g_currentCityName);
        },
        setG_UserInfo(state, g_UserInfo) {
            state.g_UserInfo = g_UserInfo
            Lockr.set('g_UserInfo', g_UserInfo);
        },
        setG_userState(state, g_userState) {
            state.g_userState = g_userState
            Lockr.set('g_userState', g_userState);
        },
        setG_loginInfo(state, g_loginInfo) {
            state.g_loginInfo = g_loginInfo
            Lockr.set('g_loginInfo', g_loginInfo);
        },
        setG_PayOrder(state, g_PayOrder) {
            state.g_PayOrder = g_PayOrder
            Lockr.set('g_PayOrder', g_PayOrder);
        },
        setG_rechargeAmount(state, payload) {
            state.g_rechargeAmount = payload.amount;
        },
        setG_accountNumber(state, payload) {
            state.g_accountNumber = payload.number;
        },
        setG_walletInfo(state, g_walletInfo) {
            state.g_walletInfo = g_walletInfo;
            Lockr.set('g_walletInfo', g_walletInfo);
        },
        setG_currentInfo(state, g_currentInfo) {
            state.g_currentInfo = g_currentInfo;
            Lockr.set('g_currentInfo', g_currentInfo);
        },
        // 早餐
        setG_breakfastInfo(state, g_breakfastInfo) {
            state.g_breakfastInfo = g_breakfastInfo;
            Lockr.set('g_breakfastInfo', g_breakfastInfo);
        },


        setG_currentRoom(state, g_currentRoom) {
            state.g_currentRoom = g_currentRoom;
            Lockr.set('g_currentRoom', g_currentRoom);
        },
        setG_currentDiscount(state, g_currentDiscount) {
            state.g_currentDiscount = g_currentDiscount;
            Lockr.set('g_currentDiscount', g_currentDiscount);
        },
        setG_currentOrder(state, g_currentOrder) {
            state.g_currentOrder = g_currentOrder;
            Lockr.set('g_currentOrder', g_currentOrder);
        },
        setG_rechargeMsg(state, g_rechargeMsg) {
            state.g_rechargeMsg = g_rechargeMsg;
            Lockr.set('g_rechargeMsg', g_rechargeMsg);
        },
        setG_freshList(state, g_freshList){
          state.g_freshList = g_freshList
          Lockr.set('g_freshList', g_freshList);
        },
        setG_jdpay(state, g_jdpayList){
            state.g_jdpayList = g_jdpayList
            Lockr.set('g_jdpayList', g_jdpayList);
          },
        CLEARUSER(state) {
            Lockr.rm("g_UserInfo");
            Lockr.rm("g_loginInfo");
            state.g_UserInfo.Card_no = '';
            state.g_UserInfo.Card_Kind_Diplay = '';
            state.g_UserInfo.Name = '';
            state.g_UserInfo.Card_Money = '';
            state.g_UserInfo.IsOtherUser = null;
            state.g_UserInfo.OtherUserID = '';

            state.g_loginInfo.Card_no = ''
            // 这个不能去掉，Lockr只是把里面存储着的数据清楚了，表层数据还在，手动清空
        },
        FLUSHALL() {
            Lockr.flush();
        }
    },
    // 异步的数据操作
    actions: {
        clearUser({ commit, state }) {
            commit('CLEARUSER')
        },
        flushAll({ commit, state }) {
            commit('FLUSHALL')
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js